import { getCookie } from '../../../../utils/helpers';
import { useClubOtvcEligibilityMutation } from '../../../../api/registration/club/otvc/checkClubOtvcEligibility';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { Stack } from '@mui/material';
import { useOrganicRegistrationForm } from '.';
import { useDirectAccessAnalytics } from '../../../../hooks/useAnalytics';
import SplitView from '../../SplitView';
import CircularProgress from '../../../../components/CircularProgress/CircularProgress';

type UserInfoCookie = {
  email: string;
  clubCode: string;
  lastName: string;
  custKey: string;
  membershipNumber?: string;
};

const EligibilityCheck = () => {
  const navigate = useNavigate();
  const { setOtvcValues, setFormValues } = useOrganicRegistrationForm();
  const { track } = useDirectAccessAnalytics();

  const checkOtvcEligibility = useClubOtvcEligibilityMutation({
    onSuccess: (res, variables) => {
      setOtvcValues((current) => ({ ...current, ...res }));
      setFormValues((current) => ({
        ...current,
        email: variables.emailId,
        lastName: variables.lastName,
        membershipNumber: variables.membershipNumber ?? '',
      }));

      if (res.emailEligible && res.smsEligible) {
        navigate('code');
      } else if (res.emailEligible) {
        navigate('code/email');
      } else if (res.smsEligible) {
        navigate('code/sms');
      } else {
        track('Registration Started', {
          event_type: 'Link Accessed',
          location: 'Feature Card',
          registration_type: 'Organic',
          email: variables.emailId,
          login_method: 'SSO',
        });
        navigate('/club/policy');
      }
    },
    onError: () => {
      navigate('/club/policy');
    },
  });

  const checkAndParseUserCookie = (): UserInfoCookie | undefined => {
    try {
      const userInfoFromCookie = getCookie('mpr_user_info');
      const userInfo = JSON.parse(userInfoFromCookie ?? '');

      if (userInfo?.email && userInfo?.lastName) {
        return userInfo;
      } else {
        throw 'Missing required fields on cookie';
      }
    } catch (err) {
      // cookie doesn't exist or malformed, send the user to login
      navigate('login', { replace: true });
    }
  };

  useEffect(() => {
    const userInfoParsed = checkAndParseUserCookie();
    if (userInfoParsed?.email && userInfoParsed?.lastName)
      checkOtvcEligibility.mutate({
        emailId: userInfoParsed.email,
        lastName: userInfoParsed.lastName,
        membershipNumber: userInfoParsed.membershipNumber,
      });
  }, []);

  return (
    <SplitView data-testid="organic-registration-sso-1">
      <Stack alignItems="center" justifyContent="center" sx={{ height: 1 }}>
        <CircularProgress size={120} />
      </Stack>
    </SplitView>
  );
};

export default EligibilityCheck;
